export default "__VITE_ASSET__7XK$ItLM__"